import { getIsMobile } from 'config/PortalConfiguration';
import { IWorkflowCatalogNode } from './WorkflowCatalogUtils';
import { ImageInfoControl } from 'components/images/ImageInfoControl';

interface IWorkflowNodeIconProps extends IWorkflowCatalogNode {}

/**
 * Standardize Workflow node icon.
 *
 * Copyright (c) 2023 Decisions All Rights Reserved
 */
export function WorkflowNodeIcon({ icon, entityName }: IWorkflowNodeIconProps) {
  const isMobile = getIsMobile();
  const iconSize = isMobile ? 30 : 20;
  const iconClass = isMobile ? 'dp-mobile-workflow-catalog-node__icon' : 'dp-workflow-tree__icon';
  return icon ? (
    <ImageInfoControl
      className={iconClass}
      image={icon}
      width={iconSize}
      height={iconSize}
      alt={`${entityName} Icon`}
    />
  ) : null;
}
